import { type SurveyBase } from 'types/surveys';

export const getCurrentQuestionIndex = (response: SurveyBase | undefined): number =>
  response?.currentQuestionIndex ?? response?.answers?.length ?? 0;
